module.exports = __webpack_public_path__ + "img/logo_non_dark.0508517a.png";